import React from "react";
import "./Footer.css";
import { SOCIAL_LINKS } from "./data/content";
import { FaGithub, FaLinkedin, FaDribbble, FaArrowUp } from "react-icons/fa";

const ICONS = {
  github: FaGithub,
  linkedin: FaLinkedin,
  dribbble: FaDribbble,
};

const FOOTER_LINKS = [
  { href: "#top", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#experience", label: "Experience" },
  { href: "#skills", label: "Skills" },
  { href: "#work", label: "Work" },
  { href: "#contact", label: "Contact" },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <a href="#top" className="site-footer-logo">
            <span className="site-footer-mark" aria-hidden="true">JS</span>
            Jas Sabharwal
          </a>
          <p className="site-footer-tagline">
            Full-stack developer based in the Southern Ontario area.
          </p>
        </div>

        <nav className="site-footer-nav" aria-label="Footer">
          {FOOTER_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="site-footer-link">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="site-footer-socials">
          {SOCIAL_LINKS.map((link) => {
            const Icon = ICONS[link.type];
            return (
              <a
                key={link.type}
                href={link.href}
                className="site-footer-social"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
              >
                <Icon aria-hidden="true" />
              </a>
            );
          })}
        </div>
      </div>

      <div className="site-footer-bottom">
        <p className="site-footer-credit">
          Designed and built by <span className="site-footer-credit-name">Jas Sabharwal</span>
        </p>
        <span className="site-footer-copy">&copy; {year}</span>
        <a href="#top" className="site-footer-top">
          <FaArrowUp aria-hidden="true" />
          Back to top
        </a>
      </div>
    </footer>
  );
}

export default Footer;
